import { render } from "./PkIndexView.vue?vue&type=template&id=8d84cd6e&scoped=true"
import script from "./PkIndexView.vue?vue&type=script&lang=js"
export * from "./PkIndexView.vue?vue&type=script&lang=js"

import "./PkIndexView.vue?vue&type=style&index=0&id=8d84cd6e&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d84cd6e"]])

export default __exports__